/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取分销渠道自定义模板主题
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  distributionId: string,
  seriesId: string,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: cms.DistributionTheme;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/cms/distribution/theme/${distributionId}/${seriesId}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
